import { capitalize } from 'lodash'

export const capitaliseLastNames = (lastNames: string) => {
  const names = capitaliseNames(lastNames)
  return !names.includes('-')
    ? names
    : names
        .split('-')
        .map(string => capitalize(string))
        .join()
        .replaceAll(',', '-')
}

export const capitaliseNames = (names: string) => {
  return names
    .split(' ')
    .map(string => capitalize(string))
    .join()
    .replaceAll(',', ' ')
}
